<template>
    <section class="search-wrapper">
        <div class="search-area2 bgimage">
            <div class="bg_image_holder">
                <img src="/assets/images/pets.svg" alt="pets">
            </div>
            <div class="container content_above">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div class="search">
                            <div class="search__title">
                                <h3><span>{{ totalActivePets }}</span> {{$store.getters.t('catalog_search_volunteer_animals_waiting_help')}}</h3>
                            </div>
                            <div class="search__field">
                                <form action="#">
                                    <div class="field-wrapper">
                                        <input class="relative-field rounded" type="text"
                                               :placeholder="$store.getters.t('catalog_search_search_by_wards')" v-model="mainSearch">
                                        <div class="catalog-search-block" v-if="mainSearch">
                                            <div class="search-results">
                                                <div class="search-separator"
                                                     v-if="mainResults.petsWithNeedSum.length">{{$store.getters.t('catalog_search_need_help')}}
                                                </div>
                                                <div class="search-result-items"
                                                     v-if="mainResults.petsWithNeedSum.length">
                                                    <div class="search-result-item clearfix"
                                                         v-for="pet in mainResults.petsWithNeedSum">
                                                        <div class="search-result-item-avatar">
                                                            <a :href="'/pets/' + pet.id">
                                                                <img
                                                                    :src="'/storage/' + (pet.avatar.path.replace('original', 'preview_l'))">
                                                            </a>
                                                        </div>
                                                        <div class="search-result-item-name-block">
                                                            <a :href="'/pets/' + pet.id">
                                                                <p class="search-result-item-name">
                                                                    {{ pet.name }}</p>
                                                                <p class="search-result-item-desc">
                                                                    {{ pet.ad_title }}</p>
                                                            </a>
                                                        </div>
                                                        <div class="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div class="search-separator" v-if="mainResults.pets.length">{{$store.getters.t('catalog_search_seeking_friend')}}
                                                </div>
                                                <div class="search-result-items" v-if="mainResults.pets.length">
                                                    <div class="search-result-item clearfix"
                                                         v-for="pet in mainResults.pets">
                                                        <div class="search-result-item-avatar">
                                                            <a :href="'/pets/' + pet.id">
                                                                <img :src="'/storage/' + (pet.avatar.path.replace('original', 'preview_l'))">
                                                            </a>
                                                        </div>
                                                        <div class="search-result-item-name-block">
                                                            <a :href="'/pets/' + pet.id">
                                                                <p class="search-result-item-name">
                                                                    {{ pet.name }}</p>
                                                                <p class="search-result-item-desc">
                                                                    {{ pet.ad_title }}</p>
                                                            </a>
                                                        </div>
                                                        <div class="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div class="search-separator" v-if="mainResults.projects.length">
                                                    {{$store.getters.t('catalog_search_projects')}}
                                                </div>
                                                <div class="search-result-items" v-if="mainResults.projects.length">
                                                    <div class="search-result-item clearfix"
                                                         v-for="project in mainResults.projects">
                                                        <div class="search-result-item-avatar">
                                                            <a :href="'/projects/' + project.id">
                                                                <img
                                                                    :src="'/storage/' + (project.avatar.path.replace('original', 'preview_l'))">
                                                            </a>
                                                        </div>
                                                        <div class="search-result-item-name-block">
                                                            <a :href="'/projects/' + project.id">
                                                                <p class="search-result-item-name">
                                                                    {{ project.name }}</p>
                                                                <p class="search-result-item-desc">
                                                                    {{ project.ad_title }}</p>
                                                            </a>
                                                        </div>
                                                        <div class="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div class="text-center"
                                                     v-if="!mainResults.pets.length && !mainResults.projects.length && !mainResults.petsWithNeedSum.length">
                                                    {{$store.getters.t('catalog_search_nothing_found')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end /.row -->
            </div>
            <!-- end /.container -->
        </div>
        <!-- end /.search-area2 -->
    </section>
</template>

<script>

import { mapGetters } from 'vuex';

const initialResults = {
    pets: [],
    petsWithNeedSum: [],
    projects: [],
};


export default {
    name: "CatalogSearch",
    data(){
        return{
            mainSearch: '',
            mainResults: {
                pets: [],
                petsWithNeedSum: [],
                projects: [],
            },
        }
    },

    computed: {
        ...mapGetters({
            sliceState: 'sliceByKey'
        }),
        totalActivePets(){
            return this.sliceState( 'totalActivePets' );
        }
    },

    watch: {
        mainSearch(val){

            if( ! val ) return this.mainResults = { ...initialResults };

            this.searchResults();

        }
    },

    methods: {

        async searchResults(){

            try {

                const {
                    data: {
                        data: {
                            pets = [],
                            projects = [],
                            petsWithNeedSum = [],
                        },
                        success = false,
                        ...rest
                    }
                } = await axios.get( '/api/catalog/search', { params: { keyword: this.mainSearch } } );

                if( success ){
                    this.mainResults = {
                        pets,
                        projects,
                        petsWithNeedSum
                    }
                }


            } catch ( _e ) {

                console.log( _e );

            }

        }

    }

}
</script>

<style lang="scss" scoped>

.breadcrumb{
    text-align: center;
}
.search .search__title{
    text-align: center;
}
.search-wrapper {
    opacity: 1;
    position: relative;
    z-index: 60;

    .search-area2:before {
        z-index: -1;
    }

    .search-area2::after{
        display: block;
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
        background: url('/assets/images/pets.svg') no-repeat center/contain;
    }
}

.catalog-search-block {
    position: absolute;
    width: 100%;
    background-color: white;
    box-shadow: 0 0 3px 1px #ccc;
    border-radius: 15px;
    text-align: left;
    z-index: 1000;
    overflow: hidden;

    .search-results {
        position: relative;
        background-color: white;
        padding: 10px;
        width: 100%;
        z-index: 1;

        .city-item {
            cursor: pointer;
            padding: 5px 0;
        }

        .city-item:hover {
            color: #0674ec;
        }

        .search-separator {
            margin-bottom: 10px;
            margin-top: 10px;
            color: #afafaf;
        }

        .search-result-items {
            .search-result-item {
                margin-bottom: 15px;

                .search-result-item-avatar {

                    float: left;
                    margin-right: 15px;

                    img {
                        border-radius: 15px;
                        width: 50px;
                    }
                }

                .search-result-item-name-block {

                    color: #747b86;

                    .search-result-item-name {
                        font-weight: bold;
                        margin-bottom: 0;
                    }

                    .search-result-item-desc {
                        margin-bottom: 0;
                        font-size: 0.7rem;
                        color: #9e9e9e;
                        line-height: 12px;
                    }

                }
            }
        }

    }


}



</style>
